import JSEncrypt from 'jsencrypt'

// 登录接口使用的 RSA 公钥
export const LOGIN_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqH7pLBzdshdnWhDn2v+t
T0VctNwGhpX/6m4e7b6Uhnp1Mq/RS2IYARHNGs9TAqnqwJGnT8ld4fzkRfXrbhLL
kM1d1B/10tIU3gkGZCjSZu3Ix/yHdUBHS4HBwI6csTWab7hTXUlFgn1uxSmoAIlv
I3ETd4Xj5KPHgTnhCLX/QdJJ6p+4kba6nzfhG2dv35EizwZmQmlOXb/M/DTznhLw
C+wLR60af4tajZn1fDB8vOCc0gzTUoJrZGiQ3qcB9iMzbk8XCmb3zSgsr9VZ+g+Z
IMoLkxXm3ONDeU9UCQEbrywS91i+udDAqEYFM2ucnUxrctt+sC89dQrSG7kdYRmA
owIDAQAB
-----END PUBLIC KEY-----`

// 登录接口使用的 RSA 私钥（用于对报文进行签名，PKCS#1 格式）
export const LOGIN_PRIVATE_KEY = `-----BEGIN RSA PRIVATE KEY-----
MIIEvwIBADANBgkqhkiG9w0BAQEFAASCBKkwggSlAgEAAoIBAQDrJD734FM1BkgH
cZCkWowX+WA4Aeu3Ql5Zo1TSPOyvmA3oUI8JupXYxny49z0Mad+aD1yijKPco93B
KfE/M0kp7yB1bdKr8KK5FqpR7JU1VkSM310xKltaEOTVBi2eLy33i/HiCGJ2rLy1
wALibiu7WhfaYOMYpfffD1iEsvuaSGwxWFThyZbJC0VF46OzaXRV3+NIJ9XxNB7O
+3xXsNAzgPvYII3WfaQGCniJosBpASzSTfLrdj1EfO+9VsY7lHkkXMNC2glx7CNl
ItGzwJ2WgKQ/EXRPwvF+vR9haf705AWZuBfCVC6uX4Id8WziegYAKhAu8LYDsZab
0EMmlK+1AgMBAAECggEAF5lBZYyipSdueqrD1q7MsQpCxRQyRSfYwrvA40GgimXi
/W36UQJkEAeplEGh45lLitFgXWLqfhYHByAPuWVLAjWgxxBAzKc/mX5EFSk+d0Yj
ZpTzLCBBX0pjQNrYILBA939YxPPM9/aRkNcGoxVl961MyAqhuANOG1mVq2mwFRVe
3kWl70aVN2Tn4KHFkO8fywZXiDbo311eViPV+q0hiuAdxVZYA4tpp3aa+KK+MDQy
f6vuVUCNaHsfmXcKbCPF/E14GQWUeJFW7ofGwIjhk0GvxayNB9wXutrSsTtnQ1Qr
MJt8j3KuuEzCET5q/scNa5bhQev3VYjloHZn4TWmeQKBgQD6pPu0/L6VWB8hbv5/
zePDy44GQXuDfJFj9Ydx2e6rGrLnJzc6mHtSZc145PXBUkXnLEAwIHReM3uxdMVt
Sw/6PnCsjQic482Aby97C2LIHSVCWs/kP8yk5dgc7/Ch6nUeSH32TdHTHRZqdc77
NgwC5oCLvalOCw40NRU1hOpRzQKBgQDwKnZnA1pUPSk8rhHdGV5jk26Yaf6mB675
Bu1OxQ8sP6IfVooqpCI1LcIpxtdKxleuoGIzvNWcWk22Vca+PKG4pVA6sap7mj3V
JWNuxvk50ccUHIFeEgolXamzQ5JQCp7pxzFi2z6FDyGNgzytjClYjsvNzH5nGu3k
84enMaWNiQKBgQC36EyETRsuC52z83QrpI+lv3rzXiLZpJItjR+XyzeTNqDkeOLO
TMnX+LieJymncs21xMNITNf1ssLkv3CJNBWCIUSdZ1JVg9Tqkyp8lysg+Dm5iVaW
/LUUnU1IVknzFExhLwG1sv3tcJ9c+BoqO0ru6eCSKFTM3dHLPtPUFDW2VQKBgQDJ
FyTQmDQX+KYAkteOQ2GPCrE9mPKJXkGZbb1hiQptSFKc3r8NeSTTVh8PD9jQWUat
hsjy/Rf2tH4BP80LGIVor7J/kqdmmv1O7OFWre+cBBQmuL9xXrV0F/qxiNCHiH0K
zaiCV4T/sG2tqccyoPs1lUr8ZE8qUZgDbg2VZrJx0QKBgQC0LcMyiWKSjKQSKq6a
6CTLpI8wEZoJdwoaFt24uIKCqtzsvfLwtTqzDsXnYqQEAeHNC+95QwwnToi4a8/s
rX0i2/CdL4KyPHwAnyElRb56ezSjWxoMHOBpBlUvikOlTrPe/xGZb+uIKP0TBxF2
y7/AWJvjFVNImpDzisYcw1ymhw==
-----END RSA PRIVATE KEY-----`

/**
 * 使用 RSA 公钥加密单个字段
 * @param {string} data - 需要加密的字符串
 * @returns {string} - 加密后的字符串
 */
export function encryptByPublicKey(data) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(LOGIN_PUBLIC_KEY)
  return encrypt.encrypt(data)
}

/**
 * 生成随机的 16 位 base64 字符串作为 sign 占位
 * @returns {string} - 随机的 16 位 base64 字符串
 */
function generateRandomSign() {
  // 生成 12 字节的随机数（base64 编码后约 16 位）
  const randomBytes = new Uint8Array(50)
  if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(randomBytes)
  } else {
    for (let i = 0; i < randomBytes.length; i++) {
      randomBytes[i] = Math.floor(Math.random() * 256)
    }
  }
  // 转 base64 并去掉末尾的 '='
  return btoa(String.fromCharCode.apply(null, randomBytes)).replace(/=+$/, '==')
}

/**
 * 加密并签名登录数据
 * 1. 用公钥加密敏感字段（loginName, loginPwd）
 * 2. 生成 sign 占位（暂未做签名验证，使用随机 base64 字符串）
 * 3. JSON请求一起上送
 * @param {Object} loginData - 登录数据对象
 * @returns {Object} - 加密签名后的登录数据
 */
export function encryptAndSignLoginData(loginData) {
  // 1. 用公钥加密敏感字段
  const encryptedData = {
    loginName: encryptByPublicKey(loginData.loginName),
    loginPwd: encryptByPublicKey(loginData.loginPwd),
    roleId: loginData.roleId,
    channelCode: loginData.channelCode
  }

  // 2. 生成随机的 16 位 base64 字符串作为 sign 占位
  const signature = generateRandomSign()

  // 3. 组装最终请求体
  return {
    ...encryptedData,
    sign: signature
  }
}
